import {Component} from '@angular/core';
/**
 * \@title Datepicker API
 */
export class DatepickerApiExample {
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'datepicker-api-example',
  templateUrl: 'datepicker-api-example.html',
  styleUrls: ['datepicker-api-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DatepickerApiExample_tsickle_Closure_declarations() {
/** @type {?} */
DatepickerApiExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatepickerApiExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
